module.exports = __webpack_public_path__ + "abecb72d.otf";